import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import PlanModalPlanSingle from "./planModalPlanSingle";
import {updatePartnerPlan} from "../../Actions/planUpgradeAction";
import {checkIfWithoutSMSAvailable, getSubscriptionType} from "../../Util/dataHelper";
import { plansSelector } from "../../Reducers/plansReducer";
import {ALLOW_PLAN_UPGRADE_PARTNER_ID_LIST} from "../../Util/hardcode";

const PlanUpgradeModal = ({selectedCompanyId}) => {
    const partnerAccountObj = useSelector(state => state.partnerAccounts);
    const partnerDetails = useSelector(state => state.partnerDetails);
    const selectedCompanyDetails = partnerAccountObj?.getAccountDetailsByCompanyId(selectedCompanyId);
    const [selectedPlan, setSelectedPlan] = useState("");
    const [showSMSToggle, setShowSMSToggle] = useState(false);
    const [planUpgradeText, setPlanUpgradeText] = useState("");
    const [isUpdating, setIsUpdating] = useState(false);
    const plansObj = useSelector(plansSelector);
    const dispatch = useDispatch();
    
    const isUpgradeAllowed = partnerDetails && ALLOW_PLAN_UPGRADE_PARTNER_ID_LIST.includes(partnerDetails.id);

    useEffect(() => {
        setSelectedPlan(plansObj.getDisplayName(selectedCompanyDetails?.currentPlanRaw));
        setShowSMSToggle(checkIfWithoutSMSAvailable(selectedCompanyDetails?.country));
    }, [selectedCompanyDetails?.country, selectedCompanyDetails?.currentPlanRaw, selectedCompanyId, plansObj])

    useEffect(() => {
        setPlanUpgradeText("");
        setIsUpdating(false);
        return () => {
            setPlanUpgradeText("");
            setIsUpdating(false);
        };
    }, [selectedCompanyId]);

    if (partnerAccountObj === null) return <></>

    const getCurrentPlan = () => {
        return plansObj.getDisplayName(selectedCompanyDetails?.currentPlanRaw);
    }

    const handleUpdateClicked = async () => {
        if (selectedPlan === getCurrentPlan()) return;
        
        if (isUpdating) return;

        if (isUpgradeAllowed) {
            setIsUpdating(true);
            setPlanUpgradeText("");
            try {
                await dispatch(updatePartnerPlan(selectedCompanyDetails.companyId, selectedCompanyDetails.dispatcherId, getSubscriptionType(selectedPlan)));
            } catch (e) {
                console.error(e);
                setPlanUpgradeText("Failed to update plan. Please try again or contact support.");
            } finally {
                setIsUpdating(false);
            }
        } else {
            setPlanUpgradeText("To update plans, please reach out to your partner contact or contact Shipday support at support@shipday.com.");
        }
    }

    

    return (
        <div className="modal fade" id="planUpgradeModal" tabIndex="-1" aria-labelledby="planUpgradeModalLabel"
             aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title text-start w-100" id="planUpgradeModalLabel">Upgrade Company Plan</h3>
                        <button type="button" className="sd-close" data-bs-dismiss="modal"
                                aria-label="Close">
                            <svg width="12" height="11" viewBox="0 0 12 11" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.6875 9.3125C11.0938 9.6875 11.0938 10.3438 10.6875 10.7188C10.5 10.9062 10.25 11 10 11C9.71875 11 9.46875 10.9062 9.28125 10.7188L6 7.4375L2.6875 10.7188C2.5 10.9062 2.25 11 2 11C1.71875 11 1.46875 10.9062 1.28125 10.7188C0.875 10.3438 0.875 9.6875 1.28125 9.3125L4.5625 6L1.28125 2.71875C0.875 2.34375 0.875 1.6875 1.28125 1.3125C1.65625 0.90625 2.3125 0.90625 2.6875 1.3125L6 4.59375L9.28125 1.3125C9.65625 0.90625 10.3125 0.90625 10.6875 1.3125C11.0938 1.6875 11.0938 2.34375 10.6875 2.71875L7.40625 6.03125L10.6875 9.3125Z"
                                    fill="#242424"/>
                            </svg>
                        </button>
                    </div>
                    <div className="modal-body text-center">
                        {planUpgradeText && <div className="alert alert-danger mt-4">{planUpgradeText}</div>}
                        <div className="d-flex pt-4 plan-cards-holder">
                            <PlanModalPlanSingle currentPlan={getCurrentPlan()} planText={"Starter"} 
                                                 description={"Basic features for getting started"} selectedPlan={selectedPlan} setSelect={setSelectedPlan}/>
                            <PlanModalPlanSingle currentPlan={getCurrentPlan()} planText={"Professional"} 
                                                 description={"Advanced features for growing businesses"} selectedPlan={selectedPlan} setSelect={setSelectedPlan} showWithSMSToggle={showSMSToggle}/>
                            <PlanModalPlanSingle currentPlan={getCurrentPlan()} planText={"Branded Premium"}
                                                 description={"White-label solution with premium support"} selectedPlan={selectedPlan} setSelect={setSelectedPlan} showWithSMSToggle={showSMSToggle}/>
                            <PlanModalPlanSingle currentPlan={getCurrentPlan()} planText={"Branded Elite"}
                                                 description={"Elite features and priority support"} selectedPlan={selectedPlan} setSelect={setSelectedPlan}/>
                            <PlanModalPlanSingle currentPlan={getCurrentPlan()} planText={"Business AI"}
                                                 description={"AI-powered features for enterprise"} selectedPlan={selectedPlan} setSelect={setSelectedPlan}/>
                        </div>
                        <div className="mt-4 d-flex justify-content-end">
                            <div data-bs-dismiss="modal" aria-label="Close"
                                 className="sd-secondary-btn px-4 me-2">Cancel
                            </div>
                            <div className={`sd-primary-btn px-4 ${isUpdating ? 'disabled' : ''}`}
                                 onClick={handleUpdateClicked}
                                 style={{pointerEvents: isUpdating ? 'none' : 'auto', opacity: isUpdating ? 0.6 : 1, cursor: isUpdating ? 'not-allowed' : 'pointer'}}>
                                {isUpdating ? 'Updating...' : 'Upgrade'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlanUpgradeModal;

